import React from 'react'
import styled from 'styled-components'
import { Row, Section } from 'components/Layout'
import { LinkButton } from 'components/Shared'
import { StaticImage } from 'gatsby-plugin-image'
import { media } from 'styled-bootstrap-grid'
import { getOutlink } from '../../utils/analyticsUtils'

const StyledSubTitle = styled.p`
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-size: 20px;
  text-align: center;
  ${media.md`
  padding: 0px;
  `}
  padding: 16px 8px;
`

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.background.dark};
  border-radius: 24px;
  color: white;
  ${media.sm`
    padding: 40px 60px;
  `}
  padding: 40px 8px;
`

const YellowText = styled.span`
  color: ${({ theme }) => theme.palette.secondary.main};
`

const Title = styled.h2`
  max-width: 550px;
  padding: 16px 8px;
  text-align: center;
  margin: auto;
  font-weight: ${({ theme }) => theme.fontWeights.titleBold};
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

const PrimaryButtonWrapper = styled.div`
  margin: 8px 0;
`

const MarketplaceBadge = styled.div`
  display: grid;
  place-items: center;
  margin: 16px 0 8px;
  
  & img {
    width: 200px;
    height: auto;
  }
`

const SecondaryButtonsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

const Br = styled.br`
  display: none;
  ${media.sm`
    display: block;
  `}
`

const SecondaryLinkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  min-width: 160px;
  background-color: transparent;
  font-family: ${({ theme }) => theme.fontFamilies.main};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.body2};
  letter-spacing: 1.5px;
  color: ${({ theme }) => theme.palette.secondary.main};
  border-color: ${({ theme }) => theme.palette.secondary.main};
  border: 2px solid;
  border-radius: 8px;
  padding: 0 16px;
  text-decoration: none;
  transition: all 0.25s ease-in;
  &:hover {
    color: white;
    background-color: ${({ theme }) => theme.palette.secondary.main};
    border-color: ${({ theme }) => theme.palette.secondary.main};
  }
`

const PoweredByWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
`

const SignupSlice = ({ sliceTitle }) => {
  const marketplaceLink =
    'https://aws.amazon.com/marketplace/pp/prodview-pu4mwhubtiatc?trk=41156f33-2a52-4124-8993-f9cde0e7aaab&sc_channel=el&source=semplates'
  const sliceContent = {
    sliceTitle: sliceTitle ?? [
      <Title key="title">
        Start sending&nbsp;
        <YellowText>great emails</YellowText>
        <Br /> with <YellowText>Amazon SES,</YellowText>&nbsp;hassle free!
      </Title>,
    ],
    subTitle: (
      <StyledSubTitle>
        Our discover plan is free forever. No credit card required. <br /> Need
        more functionalities? You can upgrade anytime.
      </StyledSubTitle>
    ),
    button: {
      to: getOutlink(),
      label: 'Get started now for free',
    },
  }

  return (
    <Section>
      <Container>
        {sliceContent.sliceTitle}
        <Row alignItems="center" justifyContent="center">
          {sliceContent.subTitle}
        </Row>
        <ContentWrapper>
          <PrimaryButtonWrapper>
            <LinkButton
              to={sliceContent.button.to}
              label={sliceContent.button.label}
              size="sm"
            />
          </PrimaryButtonWrapper>
          <MarketplaceBadge>
            <StaticImage
              src="../../images/aws-marketplace-white.png"
              alt="Available on AWS Marketplace"
              placeholder="none"
            />
          </MarketplaceBadge>
          <SecondaryButtonsRow>
            <SecondaryLinkButton
              href={marketplaceLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Try Free with AWS
            </SecondaryLinkButton>
          </SecondaryButtonsRow>
          <PoweredByWrapper>
            <StaticImage
              src="../../images/aws-partner.png"
              alt="AWS Partner"
              placeholder="none"
              height={48}
            />
          </PoweredByWrapper>
        </ContentWrapper>
      </Container>
    </Section>
  )
}

export default SignupSlice
